import { Link } from "react-router-dom";
import { ArrowRight, Clock, MapPin } from "lucide-react";
import { FaInstagram, FaLinkedin, FaTwitter } from "react-icons/fa6";
import { FaPhone, FaEnvelope } from "react-icons/fa";

import logo from "../assets/logo.jpg";

export default function Footer() {
  return (
    <footer className="bg-green-950 text-white px-10 py-12">
      {/* TOP GRID */}
      <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
        {/* COLUMN 1 - LOGO */}
        <div>
          <img src={logo} alt="Logo" className="w-7 h-auto object-contain" />
          <span className="text-white text-sm font-medium mt-1 ml-1">
            DELIVERY{" "}
          </span>

          <p className="text-gray-300 mt-3 text-sm">
            Small delivery platform under peratic Capital simplifying last-mile
            logistics across Africa.
          </p>

          {/* SOCIAL ICONS */}
          <div className="flex items-center gap-4 mt-4">
            <a href="https://instagram.com" target="_blank" rel="noreferrer">
              <FaInstagram className="text-pink-500 hover:scale-110 transition" />
            </a>

            <a
              href="https://www.linkedin.com/company/jopo-delivery/?viewAsMember=true"
              target="_blank"
              rel="noreferrer"
            >
              <FaLinkedin className="text-blue-500 hover:scale-110 transition" />
            </a>

            <a href="https://x.com" target="_blank" rel="noreferrer">
              <FaTwitter className="text-sky-400 hover:scale-110 transition" />
            </a>
          </div>
        </div>

        {/*QUICK LINKS */}
        <div>
          <h3 className="font-semibold mb-4">Quick Links</h3>

          <ul className="space-y-2 text-gray-300 text-sm">
            {[
              { name: "Home", path: "/" },
              { name: "About Us", path: "/about" },
              { name: "Services", path: "/services" },
              { name: "Careers", path: "/careers" },
            ].map((item, i) => (
              <li key={i}>
                <Link
                  to={item.path}
                  className="flex items-center gap-2 hover:text-orange-400 transition"
                >
                  <ArrowRight size={14} className="text-orange-400" />
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        {/* POLICIES */}
        <div>
          <h3 className="font-semibold mb-4">Policies</h3>

          <ul className="space-y-2 text-gray-300 text-sm">
            <li>
              <Link
                to="/policies"
                className="flex items-center gap-2 hover:text-orange-400"
              >
                <ArrowRight size={14} className="text-orange-400" />
                Privacy Policy
              </Link>
            </li>

            <li>
              <Link
                to="/policies"
                className="flex items-center gap-2 hover:text-orange-400"
              >
                <ArrowRight size={14} className="text-orange-400" />
                Data Protection Policy
              </Link>
            </li>

            <li>
              <Link
                to="/policies/driver-privacy"
                className="flex items-center gap-2 hover:text-orange-400"
              >
                <ArrowRight size={14} className="text-orange-400" />
                Rider Policy
              </Link>
            </li>

            <li>
              <Link
                to="/policies"
                className="flex items-center gap-2 hover:text-orange-400"
              >
                <ArrowRight size={14} className="text-orange-400" />
                Refund Policy
              </Link>
            </li>
          </ul>
        </div>

        {/*CONTACT */}
        <div>
          <h3 className="font-semibold mb-4">Contact</h3>

          <div className="space-y-2 text-gray-300 text-sm">
            <p className="flex items-center gap-2">
              <FaEnvelope className="text-orange-400" />
              support@jopodelivery.com
            </p>

            <p className="flex items-center gap-2">
              <FaPhone className="text-orange-400" />
              +255 689 966 875
            </p>

            <p className="flex items-center gap-2">
              <MapPin className="text-orange-400" />
              kijitonyama, Dar Es Salaam, Tanzania.
            </p>
          </div>
        </div>

        {/* COLUMN 5 - OFFICE HOURS */}
        <div>
          <h3 className="font-semibold mb-4">Office Hours</h3>

          <div className="text-gray-300 text-sm space-y-3">
            <div className="flex items-start gap-2">
              <Clock
                size={14}
                className="text-white-400 mt-[2px] flex-shrink-0"
              />
              <p>
                <span className="text-white font-medium">Mon - Sat:</span>{" "}
                8:00AM - 6:00PM
              </p>
            </div>

            <div className="flex items-start gap-2">
              <Clock size={14} className="opacity-0 mt-[2px] flex-shrink-0" />
              <p>
                <span className="text-white font-medium">Sunday:</span> Closed
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* DIVIDER LINE */}
      <div className="border-t border-white-400 mt-10 pt-6"></div>

      {/* BOTTOM BAR WITH VERTICAL LINE */}
      <div className="flex justify-between items-center text-gray-400 text-sm">
        <p>© {new Date().getFullYear()} Jopo Delivery. All rights reserved.</p>

        <div className="flex items-center gap-3">
          <div className="w-[1px] h-4 bg-white/60"></div>

          <Link to="/policies" className="hover:text-orange-400 transition">
            Terms & Conditions
          </Link>
        </div>
      </div>
    </footer>
  );
}
